function TemplateVO(id, name, creationDate, reconnaissance, physicalExamination, recommendations, diagnosisList,
                    medicalProcedures, prescribedDrugs, doctor, user) {
    this.id = id;
    this.name = name;
    this.doctor = doctor;
    this.creationDate = creationDate;
    this.reconnaissance = reconnaissance;
    this.physicalExamination = physicalExamination;
    this.recommendations = recommendations;
    this.diagnosisList = medicalProcedures || [];
    this.medicalProcedures = diagnosisList || [];
    this.prescribedDrugs = prescribedDrugs || [];
    this.user = user;

    var _typeContext = {
        diagnosisList: DiagnosisVO,
        medicalProcedures: MedicalProcedureVO,
        prescribedDrugs: PrescribedDrugVO,
        creationDate: Date,
        doctor: DoctorVO,
        user: UserVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}

TemplateVO.fromVisitCard = function (visitCard) {
    var template = new TemplateVO();
    template.reconnaissance = visitCard.reconnaissance;
    template.physicalExamination = visitCard.physicalExamination;
    template.recommendations = visitCard.recommendations;
    template.diagnosisList = visitCard.diagnosisList.map(removeId);
    template.medicalProcedures = visitCard.medicalProcedures.map(removeId);
    template.prescribedDrugs = visitCard.prescribedDrugs.map(removeId);
    return template;

    function removeId(item) {
        var itemClone = angular.copy(item);
        delete itemClone.id;
        return itemClone;
    }
};
